<template>
  <h1>Shoe Repair</h1>

  <div class="content-section filters">

    <div class="alert alert-warning" role="alert">After setting filters or changing sorting order, click "Apply filters"
      to re-query the database</div>
    <div class="row">
      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="Processed Time From"
            v-model="selectedStartDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>

      <div class="col-md-4">
        <FormKit
            type="datepicker"
            label="Processed Time To"
            v-model="selectedEndDate"
            format="DD/MM/YYYY"
            timezone="Europe/London"
            clearable
            :key="datepickerClearedKey"
        ></FormKit>
      </div>
    </div>

    <div class="action-bar">
      <button @click="clearFilter" id="clearFilter">Clear filter</button>&#160;
      <button @click="exportZip" id="exportZip">Export Logs</button>&#160;
      <button @click="applyFilter" id="applyFilter1">Apply filter</button>
    </div>

    <div v-if="isListing">

      <easy-data-table
          v-model:server-options="serverOptions"
          :server-items-length="serverItemsLength"
          :headers="headers"
          :items="shoeRepairLogs"
          :search-field="searchField"
          :search-value="searchValue"
          :loading="loading"
          alternating
          border-cell
          buttons-pagination
          multi-sort
      >
        <template #header="header">
          <div class="customize-header">

            {{ header.text }}<br />

            <input v-if="header.value !== 'operations'" type="text" :id="'filter-' + header.value" @click.stop />
            <button v-else @click="applyFilter" id="applyFilter2">Apply filter</button>
          </div>
        </template>

        <template #item-order_id="item">
          <router-link :to="{ name: 'ViewOrder', params: { id: item.order_id } }">
            <div>{{ item.order_id }}</div>
          </router-link>
        </template>

        <template #item-processed_time="item">
          {{formatDateTimeEN(item.processed_time)}}
        </template>


      </easy-data-table>
    </div>
  </div>
</template>


<script setup>
import {ref, watch} from "vue";
import LogsService from "@/services/LogsService";

const shoeRepairLogs =  ref([]);
const searchField = ref("processed_time");
const searchValue = ref("");

const selectedStartDate = ref('');
const selectedEndDate = ref('');
const datepickerClearedKey = ref(0);

const forceRenderDatepicker = () => {
  datepickerClearedKey.value += 1;
};
const headers = [
  { text: "Order", value: "order_id", sortable: true  },
  { text: "Processed Time", value: "processed_time", sortable: true  },
  { text: "Value", value: "repair_value", sortable: true  },

  { text: "Actions", value: "operations" },
];

const isListing = ref(true);

const loading = ref(false);
const serverItemsLength = ref(0);
const serverOptions = ref({
  page: 1,
  rowsPerPage: 25,
  //sortBy: ["processed_time"],
  sortType: ["desc"],
  exportFormat: "none",
});

const formatDateTimeEN = (date) => {
  //25/12/2023
  const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
  var formatDate = new Date(date).toLocaleDateString('en-GB', options);
  var formatTime = new Date(date).toLocaleTimeString('en-GB');
  return formatDate+' '+formatTime;
}
const  createDateAsUTC = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
}
const loadFromServer = async () => {
  console.log(serverOptions);
  loading.value = true;
  const {
    serverCurrentPageItems,
    serverTotalItemsLength,
  } = await LogsService.searchShoeRepairLogs(serverOptions.value);
  shoeRepairLogs.value = serverCurrentPageItems;
  serverItemsLength.value = serverTotalItemsLength;
  loading.value = false;
};

const applyFilter = () => {
  let filters = {};
  let updateOptions = serverOptions.value;
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = document.getElementById("filter-" + filterProperty).value;
    }
  }
  updateOptions.filters = filters;

  if (selectedStartDate.value !== "" && typeof selectedStartDate.value != "undefined") {
    selectedStartDate.value = createDateAsUTC(new Date(selectedStartDate.value));
    updateOptions.start_date = selectedStartDate.value;
  }
  if (selectedEndDate.value !== "" && typeof selectedEndDate.value != "undefined") {
    selectedEndDate.value = createDateAsUTC(new Date(selectedEndDate.value));
    updateOptions.end_date = selectedEndDate.value;
  }

  serverOptions.value = updateOptions;
  loadFromServer();
};

const exportZip = async () => {
  loading.value = true;
  await LogsService.downloadShoeRepairLogs(serverOptions.value);
  loading.value = false;
};

const clearFilter = () => {
  let filters = {};
  for (let i = 0; i < headers.length; i++) {
    const filterProperty = headers[i].value;
    if (filterProperty !== "operations") {
      filters[headers[i].value] = "";
      document.getElementById("filter-" + filterProperty).value = "";
    }
  }

  const updateServerOptions = serverOptions.value;
  updateServerOptions.filters = filters;
  updateServerOptions.start_date = "";
  updateServerOptions.end_date = "";
  selectedStartDate.value = null;
  selectedEndDate.value = null;
  forceRenderDatepicker();
  serverOptions.value = updateServerOptions;

  loadFromServer();
};

// initial load
loadFromServer();

watch(() => serverOptions.value.page, () => {
  applyFilter()
});

</script>